import { Box, Chip, ListItem } from "@mui/material";
import { keyframes, styled } from "@mui/material/styles";

const pulseGlow = keyframes`
  0%, 100% {
    box-shadow: 0 0 20px rgba(25, 118, 210, 0.1);
  }
  50% {
    box-shadow: 0 0 30px rgba(25, 118, 210, 0.3);
  }
`;

export const DocumentUnavailableChip = styled(Chip)(({ theme }) => ({
  fontSize: theme.breakpoints.down("sm") ? "0.7rem" : "0.85rem",
  height: theme.breakpoints.down("sm") ? 24 : 28,
  backgroundColor: "rgba(103, 58, 183, 0.08)",
  color: "#673AB7",
  border: "1px solid",
  borderColor: "rgba(103, 58, 183, 0.2)",
  transition: "all 0.2s ease-in-out",
  boxShadow: "0 2px 4px rgba(103, 58, 183, 0.05)",
  position: "relative",
  "& .MuiChip-label": {
    paddingLeft: theme.breakpoints.down("sm") ? 8 : 12,
    paddingRight: theme.breakpoints.down("sm") ? 8 : 12,
    fontWeight: 700,
    fontSize: theme.breakpoints.down("sm") ? "0.85rem" : "1rem",
    letterSpacing: 0.2,
  },
  "&:hover": {
    backgroundColor: "rgba(103, 58, 183, 0.12)",
  },
  "&::after": {
    content: '""',
    position: "absolute",
    bottom: -2,
    left: "50%",
    transform: "translateX(-50%)",
    width: "80%",
    height: 2,
    backgroundColor: "rgba(103, 58, 183, 0.1)",
    borderRadius: 1,
  },
}));

export const DocumentUnavailableIcon = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 16,
  height: 16,
  borderRadius: "50%",
  backgroundColor: "rgba(103, 58, 183, 0.1)",
  color: "#673AB7",
  fontSize: "0.75rem",
  fontWeight: "bold",
}));

export const StyledCard = styled(ListItem, {
  shouldForwardProp: (prop) =>
    prop !== "hasDocument" &&
    prop !== "isUploading" &&
    prop !== "isDragOver" &&
    prop !== "disabled" &&
    prop !== "isDragDropEnabled",
})<{
  hasDocument?: boolean;
  isUploading?: boolean;
  isDragOver?: boolean;
  disabled?: boolean;
  isDragDropEnabled?: boolean;
}>(({ theme, hasDocument, isUploading, isDragOver, disabled }) => ({
  borderRadius: 8,
  border: "2px dashed",
  borderColor: isDragOver
    ? theme.palette.primary.main
    : isUploading
      ? theme.palette.primary.main
      : theme.palette.grey[200],
  boxShadow: isDragOver
    ? "0 8px 32px rgba(25, 118, 210, 0.2)"
    : isUploading
      ? "0 4px 20px rgba(25, 118, 210, 0.15)"
      : "none",
  backgroundColor: isDragOver ? "rgba(25, 118, 210, 0.02)" : "#fafafa",
  position: "relative",
  opacity: disabled ? 0.4 : 1,
  transition: "all 0.3s ease-in-out",
  cursor: isDragOver ? "copy" : "default",
  pointerEvents: disabled ? "none" : "auto",
  ...(!disabled &&
    !hasDocument &&
    !isUploading &&
    !isDragOver && {
      "& .MuiListItemIcon-root, & .MuiListItemText-root": {
        opacity: 0.6,
      },
    }),
  ...(isUploading && {
    animation: `${pulseGlow} 2s ease-in-out infinite`,
  }),
  height: 120,
}));

export const BottomRightBox = styled(Box)({
  position: "absolute",
  bottom: 12,
  right: 12,
  zIndex: 1,
});
